import { useState, useEffect } from 'react';
import { useUIStore } from '@/state/useUIStore';
import './GameLoader.css';

interface GameLoaderProps {
  sceneReady: boolean;
}

export function GameLoader({ sceneReady }: GameLoaderProps) {
  const progress = useUIStore((s) => s.loadProgress);
  const label = useUIStore((s) => s.loadLabel);
  const [visible, setVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  // Once scene signals ready, fade out
  useEffect(() => {
    if (sceneReady) {
      setFadeOut(true);
      const timer = setTimeout(() => setVisible(false), 600);
      return () => clearTimeout(timer);
    }
  }, [sceneReady]);

  if (!visible) return null;

  return (
    <div className={`game-loader ${fadeOut ? 'fade-out' : ''}`}>
      <h1 className="gl-title">VAGARIO</h1>
      <div className="gl-bar-track">
        <div className="gl-bar-fill" style={{ width: `${progress}%` }} />
      </div>
      <div className="gl-info">
        <span className="gl-label">{label}</span>
        <span className="gl-pct">{Math.round(progress)}%</span>
      </div>
    </div>
  );
}
